module.exports = "<div class=\"img-container\">\r\n  <div class=\"title\">{{imgName}}</div>\r\n  <div class=\"img\"><img [src]=\"imgUrl\" alt=\"imgName\" class=\"snapshot-img\"></div>\r\n  <div class=\"img-notes\">{{imgNotes}}</div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modal-image-view/modal-image-view.component.html
// module id = ./src/app/modal-image-view/modal-image-view.component.html
// module chunks = main